// extracted by mini-css-extract-plugin
export var option = "_c2-0";
export var optionCard = "_c2-f";
export var optionContent = "_c2-g";
export var optionIcon = "_c2-i";
export var optionIconBox = "_c2-h";
export var optionLabel = "_c2-j";
export var optionPill = "_c2-m";
export var optionPillBadge = "_c2-p";
export var optionPillIcon = "_c2-n";
export var optionPillLabel = "_c2-o";
export var optionRadio = "_c2-k";
export var optionRadioInner = "_c2-l";
export var optionReveal = "_c2-2";
export var optionRevealDelay0 = "_c2-3";
export var optionRevealDelay1 = "_c2-4";
export var optionRevealDelay10 = "_c2-d";
export var optionRevealDelay11 = "_c2-e";
export var optionRevealDelay2 = "_c2-5";
export var optionRevealDelay3 = "_c2-6";
export var optionRevealDelay4 = "_c2-7";
export var optionRevealDelay5 = "_c2-8";
export var optionRevealDelay6 = "_c2-9";
export var optionRevealDelay7 = "_c2-a";
export var optionRevealDelay8 = "_c2-b";
export var optionRevealDelay9 = "_c2-c";
export var optionSelected = "_c2-1";